import { z } from "zod";
import { isoAndUnixZodSchema } from "../date-time/iso-and-unix";
import { translatableZodSchema } from "../translations/translation";

const groupReferenceZodObject = z.object({
    key: z.string().min(6),
    eventAt: isoAndUnixZodSchema,
    title: translatableZodSchema,
});

type GroupReference = z.infer<typeof groupReferenceZodObject>;

const groupReferenceFactory = (params: GroupReference): GroupReference => {
    return {
        ...params,
    };
};

export { groupReferenceFactory, groupReferenceZodObject };
export type { GroupReference };
